import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';

import moment from 'moment';

//Services
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { APP_COLLEGE, APP_COUNCIL, APP_HOSPITAL, APP_STATES, GET_ELEGIBLE_DATA, UPDATEELEGIBLE, UPLOADELIGIBLEIMG } from '../../../config/ApiConstant';
import {
    bloodGroupList,
    categoryList,
    convertDateFrom,
    degreeList,
    ELIGIBLENAME,
    freshApplicationName,
    freshApplicationOtherStateName,
    IMAGE_BASEURL,
    transferApplicationName,
    TRANSFERTOGUJNAME,
    VIEW_APP_CHANGE_STATUS_DROPDOWN
} from '../../../appconfig/Settings';
import Loader from '../../../components/Loadeer/Loader';

export const EligibleViewForm = () => {
    document.title = 'Eligible Form Details | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    // Parameters
    const { fileNo }: any = useParams();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [collegesList, setCollegesList] = useState<any>([]);
    const [statesList, setStatesList] = useState<any>([]);
    const [councilsList, setCouncilsList] = useState<any>([]);
    const [hospitalsList, setHospitalsList] = useState<any>([]);
    const [fileDetails, setFileDetails] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [updateLoader, setUpdateLoader] = useState<boolean>(false);
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getColleges();
        getStates();
        getAllCouncil();
        getAllHospital();
        getFileDetails();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get colleges
    const getColleges = async () => {
        try {
            const response = await getAllDetails(APP_COLLEGE + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCollegesList([]);
                } else {
                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setCollegesList(collegeData);
                }
            } else {
                setCollegesList([]);
            }
        } catch (error: any) {
            setCollegesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all council
    const getAllCouncil = async () => {
        try {
            const response = await getAllDetailsDirect(APP_COUNCIL);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCouncilsList([]);
                } else {
                    let councilData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const councilObj: any = {};
                        councilObj['name'] = DataList[i].Name;
                        councilObj['code'] = DataList[i].SrNo;
                        councilData.push(councilObj);
                    }
                    setCouncilsList(councilData);
                }
            } else {
                setCouncilsList([]);
            }
        } catch (error: any) {
            setCouncilsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all hospital
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(APP_HOSPITAL + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setHospitalsList([]);
                } else {
                    let hospitalData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const hospitalObj: any = {};
                        hospitalObj['name'] = DataList[i].HospName;
                        hospitalObj['code'] = DataList[i].HospNo;
                        hospitalData.push(hospitalObj);
                    }
                    setHospitalsList(hospitalData);
                }
            } else {
                setHospitalsList([]);
            }
        } catch (error: any) {
            setHospitalsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get file details
    const getFileDetails = async () => {
        try {
            setPageLoad(true);
            const response = await getAllDetails(GET_ELEGIBLE_DATA + '?fileNo=' + atob(fileNo));
            if (response) {
                response['BOD'] = moment(response.BOD, 'YYYY-MM-DD').toDate();
                response['BloodGr'] = { name: response.BloodGr, code: response.BloodGr };
                response['Category'] = { name: response.Category, code: response.Category };
                response['Degree'] = { name: response.DegNm, code: response.DegSrNo };
                response['OtherDegree'] = { name: response.OtherDegNm, code: response.OtherDegSrNo };
                response['College'] = { name: response.ColName, code: response.ColSrNo };
                response['State'] = { name: response.PState, code: response.PStateSrNo };
                response['ACState'] = { name: response.AState, code: response.AStateSrNo };
                if (!window.cn(response?.HSCYr)) {
                    response['HSCYr'] = new Date(response?.HSCYr);
                }
                if (!window.cn(response?.SSCYr)) {
                    response['SSCYr'] = new Date(response?.SSCYr);
                }
                if (!window.cn(response?.JoingYth)) {
                    response['JoingYth'] = new Date(response?.JoingYth);
                }
                if (!window.cn(response?.Passedyth)) {
                    response['Passedyth'] = new Date(response?.Passedyth);
                }

                setFileDetails(response);
                setPageLoad(false);
            }
        } catch (error: any) {
            setPageLoad(false);

            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (
            name === 'BOD' ||
            name === 'Gender' ||
            name === 'BloodGr' ||
            name === 'Category' ||
            name === 'SSCYr' ||
            name === 'HSCYr' ||
            name === 'JoingYth' ||
            name === 'Passedyth' ||
            name === 'State' ||
            name === 'POSTState' ||
            name === 'ACState' ||
            name === 'Degree' ||
            name === 'College' ||
            name === 'OtherDegree' ||
            name === 'OtherCollege'
        ) {
            val = e;
        } else if (name === 'electoral_status' || name === 'election_deposit_status' || name === 'nomination_status' || name === 'paymnetChecked') {
            val = e.checked === true ? 1 : 0;
        } else {
            val = (e.target && e.target.value) || e.value || '';
            if (name !== 'email') {
                val = val.toUpperCase();
            }
        }
        setFileDetails({ ...fileDetails, [name]: val });
    };

    // Open view document page
    const openViewDocumentPage = () => {
        navigate('/app/application/viewEligibleDocument/' + btoa(fileDetails.SrNo) + '/' + btoa(ELIGIBLENAME) + '/' + btoa(fileDetails.applicationState));
    };

    // Open edit
    const openEdit = () => {
        setIsEditOpen(true);
    };

    const updateObject = async (obj: any) => {
        for (let key in obj) {
            if (obj[key] == 'null' || obj[key] == null) {
                obj[key] = ''; // Replace null with blank
            }
            if (obj[key] == 'Invalid date' || obj[key] == 'Invalid Date') {
                obj[key] = ''; // Replace null with blank
            }
            if (obj[key] == '0000-00-00 00:00:00.000000') {
                obj[key] = ''; // Replace null with blank
            }
        }
        // return obj;
        setFileDetails(obj);
    };

    // On submit update data
    const updateFileDetails = async () => {
        try {
            setUpdateLoader(true);
            await updateObject(fileDetails);
            let formData: any = new FormData();
            formData.append('fileNo', Number(atob(fileNo)));

            Object.keys(fileDetails).map((item: any) => {
                if (
                    item !== 'BOD' &&
                    item !== 'Gender' &&
                    item !== 'BloodGr' &&
                    item !== 'Category' &&
                    item !== 'SSCYr' &&
                    item !== 'HSCYr' &&
                    item !== 'State' &&
                    item !== 'POSTState' &&
                    item !== 'ACState' &&
                    item !== 'Degree' &&
                    item !== 'College' &&
                    item !== 'OtherDegree' &&
                    item !== 'OtherCollege' &&
                    item !== 'user' &&
                    item !== 'JoingYth' &&
                    item !== 'Passedyth' &&
                    item !== 'created_at' &&
                    item !== 'updated_at'
                ) {
                    formData.append(item, fileDetails[item]);
                }
            });
            formData.append('SSCYr', !window.cn(fileDetails?.SSCYr) ? moment(fileDetails?.SSCYr).format('YYYY-MM') : '');
            formData.append('HSCYr', !window.cn(fileDetails?.HSCYr) ? moment(fileDetails?.HSCYr).format('YYYY-MM') : '');
            formData.append('JoingYth', !window.cn(fileDetails?.JoingYth) ? moment(fileDetails?.JoingYth).format('YYYY-MM') : '');
            formData.append('Passedyth', !window.cn(fileDetails?.Passedyth) ? moment(fileDetails?.Passedyth).format('YYYY-MM') : '');

            formData.append('Gender', !window.cn(fileDetails?.Gender) ? fileDetails?.Gender : '');
            formData.append('BOD', !window.cn(fileDetails?.BOD) ? convertDateFrom(fileDetails?.BOD) : '');
            formData.append('BloodGr', !window.cn(fileDetails?.BloodGr) ? fileDetails['BloodGr']?.code : '');
            formData.append('Category', !window.cn(fileDetails?.Category) ? fileDetails['Category']?.code : '');
            formData.append('PState', !window.cn(fileDetails?.State) ? fileDetails['State']?.name : '');
            formData.append('PStateSrNo', !window.cn(fileDetails?.State) ? fileDetails['State']?.code : '');
            formData.append('AState', !window.cn(fileDetails?.ACState) ? fileDetails['ACState']?.name : '');
            formData.append('AStateSrNo', !window.cn(fileDetails?.ACState) ? fileDetails['ACState']?.code : '');
            formData.append('ColName', !window.cn(fileDetails?.College) ? fileDetails['College']?.name : '');
            formData.append('ColSrNo', !window.cn(fileDetails?.College) ? fileDetails['College']?.code : '');
            formData.append('DegNm', !window.cn(fileDetails?.Degree) ? fileDetails['Degree']?.name : '');
            formData.append('DegSrNo', !window.cn(fileDetails?.Degree) ? fileDetails['Degree']?.code : '');
            delete fileDetails['State'];
            delete fileDetails['ACState'];
            delete fileDetails['College'];
            delete fileDetails['Degree'];

            const response = await postAllData(UPDATEELEGIBLE, formData);
            if (response) {
                setUpdateLoader(false);
                getFileDetails();
            }
        } catch (error: any) {
            if (error.response) {
                setUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // New File Upload
    const onFileChange = async (event: any) => {
        /*Selected files data can be collected here.*/
        const files = event.target.files;
        //File Size Check
        const fileSize = files[0].size / 1024 / 1024;
        if (fileSize > 2) {
            alert('Please upload file size less than 2mb');
        } else {
            // Request Data
            let formData = new FormData();
            formData.append('fileNo', atob(fileNo));
            formData.append('profile_pic', files[0]);

            try {
                setPageLoad(true);

                const response = await postAllData(UPLOADELIGIBLEIMG, formData);
                if (response) {
                    getFileDetails();
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Profile Picture Uploaded Successfully...' });
                }
            } catch (error) {
                setPageLoad(false);

                //Error response
                // if (error.response) {
                // }
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Applications'} pageName={'Eligible Application'} pageTitle={'Eligible Application'} goToPage={true} />

            <div className="card mt-3">
                <p>
                    <b>Personal Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudL">SurName</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudL} autoComplete="off" id="StudL" onChange={(e) => onInputChange(e, 'StudL')} className={errors['StudL'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudF">First Name</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudF} autoComplete="off" id="StudF" onChange={(e) => onInputChange(e, 'StudF')} className={errors['StudF'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudM">Middle Name</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudM} autoComplete="off" id="StudM" onChange={(e) => onInputChange(e, 'StudM')} className={errors['StudM'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <div className="profile-pic">
                            {isEditOpen === false ? (
                                ''
                            ) : (
                                <label className="-label" htmlFor='file"'>
                                    <span className="glyphicon glyphicon-camera"></span>
                                    <span>Change Image</span>
                                </label>
                            )}
                            <input id="file" type="file" name="upload-files[]" onChange={(e) => onFileChange(e)} accept="image/png, image/jpeg" disabled={isEditOpen === false ? true : false} />
                            <img src={!window.cn(fileDetails?.Image) ? fileDetails?.Image : IMAGE_BASEURL + 'no-image.jpg'} id="output" className="img-fluid" />
                        </div>
                        {/* {!window.cn(fileDetails?.Image) && <Image style={{ float: 'right' }} src={fileDetails?.Image} alt="Image" width="150" />} */}
                    </div>
                </div>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="gender" className="mb-3">
                            Gender
                        </label>
                        <div className="grid">
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option1" name="option" value="Male" checked={fileDetails.Gender === 'Male'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option1">Male</label>
                                </div>
                            </div>
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option2" name="option" value="Female" checked={fileDetails.Gender === 'Female'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option2">Female</label>
                                </div>
                            </div>
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option2" name="option" value="Other" checked={fileDetails.Gender === 'Other'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option2">Other</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BOD">Birth Date</label>
                        <Calendar value={!window.cn(fileDetails?.BOD) && fileDetails?.BOD} onChange={(e) => onInputChange(e.value, 'BOD')} dateFormat="dd-M-yy" disabled={isEditOpen === false ? true : false} />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BOD">Birth Place</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PofBOD} autoComplete="off" id="PofBOD" onChange={(e) => onInputChange(e, 'PofBOD')} className={errors['PofBOD'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BloodGr">Blood Group</label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={fileDetails?.BloodGr}
                                name="BloodGr"
                                options={bloodGroupList}
                                filter
                                optionLabel="name"
                                placeholder="Select Blood Group"
                                onChange={(e) => onInputChange(e.value, 'BloodGr')}
                                className={errors['BloodGr'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Nationality">Nationality</label>
                        <div className="input-effect-div">
                            <InputText
                                value={fileDetails?.Nationality}
                                autoComplete="off"
                                id="Nationality"
                                onChange={(e) => onInputChange(e, 'Nationality')}
                                className={errors['Nationality'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Religion">Religion</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.Religion} autoComplete="off" id="Religion" onChange={(e) => onInputChange(e, 'Religion')} className={errors['Religion'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Category">Category</label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={fileDetails?.Category}
                                name="Category"
                                options={categoryList}
                                filter
                                optionLabel="name"
                                placeholder="Select Category"
                                onChange={(e) => onInputChange(e.value, 'Category')}
                                className={errors['Category'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>
                <hr />
                <p>
                    <b>Contact</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PPhone">Mobile No</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PPhone} autoComplete="off" id="PPhone" onChange={(e) => onInputChange(e, 'PPhone')} className={errors['PPhone'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="APhone">Second Mobile No</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.APhone} autoComplete="off" id="APhone" onChange={(e) => onInputChange(e, 'APhone')} className={errors['APhone'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PEmail">Email</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PEmail} autoComplete="off" id="PEmail" onChange={(e) => onInputChange(e, 'PEmail')} className={errors['PEmail'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>
                <hr />
                <p>
                    <b>Educational Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-4">
                        <p>
                            <b>SSC</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCSNm">School Name</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCSNm} autoComplete="off" id="SSCSNm" onChange={(e) => onInputChange(e, 'SSCSNm')} className={errors['SSCSNm'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCYr">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCYr} autoComplete="off" id="SSCYr" onChange={(e) => onInputChange(e, 'SSCYr')} className={errors['SSCYr'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.SSCYr) ? fileDetails?.SSCYr : null} onChange={(e) => onInputChange(e.value, 'SSCYr')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />

                            {/* <Calendar 
                                view="month"
                                value={!window.cn(fileDetails?.SSCYr) && fileDetails?.SSCYr } 
                                onChange={(e) => onInputChange(e.value, "SSCYr")} 
                                dateFormat="mm-yy" 
                                disabled={isEditOpen === false ? true : false}
                            /> */}
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCBrd">Board</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCBrd} autoComplete="off" id="SSCBrd" onChange={(e) => onInputChange(e, 'SSCBrd')} className={errors['SSCBrd'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <p>
                            <b>HSC</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCSNm">School Name</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCSNm} autoComplete="off" id="HSCSNm" onChange={(e) => onInputChange(e, 'HSCSNm')} className={errors['HSCSNm'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCYr">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCYr} autoComplete="off" id="HSCYr" onChange={(e) => onInputChange(e, 'HSCYr')} className={errors['HSCYr'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.HSCYr) ? fileDetails?.HSCYr : null} onChange={(e) => onInputChange(e.value, 'HSCYr')} dateFormat="M-yy" disabled={isEditOpen === false ? true : false} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCBrd">Board</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCBrd} autoComplete="off" id="HSCBrd" onChange={(e) => onInputChange(e, 'HSCBrd')} className={errors['HSCBrd'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <p>
                            <b>College</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="Degree">Qualification</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.Degree}
                                    name="Degree"
                                    options={degreeList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Degree"
                                    onChange={(e) => onInputChange(e.value, 'Degree')}
                                    className={errors['Degree'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="College">College Name</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.College}
                                    name="College"
                                    options={collegesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select College"
                                    onChange={(e) => onInputChange(e.value, 'College')}
                                    className={errors['College'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="JoingYth">Joining Year</label>

                            <Calendar view="month" value={!window.cn(fileDetails?.JoingYth) ? fileDetails?.JoingYth : null} onChange={(e) => onInputChange(e.value, 'JoingYth')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="Passedyth">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText
                                    value={fileDetails?.Passedyth}
                                    autoComplete="off"
                                    id="Passedyth"
                                    onChange={(e) => onInputChange(e, 'Passedyth')}
                                    className={errors['Passedyth'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.Passedyth) ? fileDetails?.Passedyth : null} onChange={(e) => onInputChange(e.value, 'Passedyth')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>
                    </div>
                </div>

                <hr />
                <p>
                    <b>Communication Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-6">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PAddress">Present Address</label>
                            <div className="input-effect-div">
                                <InputTextarea
                                    rows={5}
                                    cols={30}
                                    value={fileDetails?.PAddress}
                                    autoComplete="off"
                                    id="PAddress"
                                    onChange={(e) => onInputChange(e, 'PAddress')}
                                    className={errors['PAddress'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PState">State</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.State}
                                    name="PState"
                                    options={statesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select State"
                                    onChange={(e) => onInputChange(e.value, 'State')}
                                    className={errors['PState'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PDist">District</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PDist} autoComplete="off" id="PDist" onChange={(e) => onInputChange(e, 'PDist')} className={errors['PDist'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PTaluka">Taluka</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PTaluka} autoComplete="off" id="PTaluka" onChange={(e) => onInputChange(e, 'PTaluka')} className={errors['PTaluka'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PCity">City</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PCity} autoComplete="off" id="PCity" onChange={(e) => onInputChange(e, 'PCity')} className={errors['PCity'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PPIN">Pin Code</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PPIN} autoComplete="off" id="PPIN" onChange={(e) => onInputChange(e, 'PPIN')} className={errors['PPIN'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="AAddress">Professional Address</label>
                            <div className="input-effect-div">
                                <InputTextarea
                                    rows={5}
                                    cols={30}
                                    value={fileDetails?.AAddress}
                                    autoComplete="off"
                                    id="AAddress"
                                    onChange={(e) => onInputChange(e, 'AAddress')}
                                    className={errors['AAddress'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="AState">State</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.ACState}
                                    name="AState"
                                    options={statesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select State"
                                    onChange={(e) => onInputChange(e.value, 'ACState')}
                                    className={errors['AState'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ADist">District</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ADist} autoComplete="off" id="ADist" onChange={(e) => onInputChange(e, 'ADist')} className={errors['ADist'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ATaluka">Taluka</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ATaluka} autoComplete="off" id="ATaluka" onChange={(e) => onInputChange(e, 'ATaluka')} className={errors['ATaluka'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ACity">City</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ACity} autoComplete="off" id="ACity" onChange={(e) => onInputChange(e, 'ACity')} className={errors['ACity'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="APIN">Pin Code</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.APIN} autoComplete="off" id="APIN" onChange={(e) => onInputChange(e, 'APIN')} className={errors['APIN'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button icon="pi pi-caret-right" className="p-button-secondary mr-2" label="Next" onClick={openViewDocumentPage} />
                            <Button icon="pi pi-pencil" label={isEditOpen ? 'Update' : 'Edit'} onClick={isEditOpen ? () => updateFileDetails() : () => openEdit()} loading={updateLoader} />
                        </div>
                    </div>
                </div>
            </div>

            {pageLoad && <Loader />}
        </>
    );
};
